import React from 'react';
function IdCard({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M11 14.725c-1-.225-1-.575-1-.825v-.375a2.325 2.325 0 00.725-1.725v-1.124A1.702 1.702 0 009.001 9a1.698 1.698 0 00-1.749 1.675V11.8a2.326 2.326 0 00.75 1.725v.375c0 .225 0 .6-1.05.825-1.05.225-.95 1.275-.95 1.275H12a1.275 1.275 0 00-1-1.275z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M13.2 5H21v15H3V5h7.8"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M11 4h2v3h-2V4zM14 14h4.375H14zm0-4h5-5zm0 2h3.125H14z"
      />
    </svg>
  );
}

export default IdCard;
